const Skeleton = {
  defaultProps: {
    startColor: '#F8F8F8',
    endColor: '#EFEFEF',
    fadeDuration: 1,
  },
};

export default Skeleton;
